(function () {
  'use strict';

  if (window.CozyologyMeasurementReport) return;

  var VERSION = '2';
  var STORAGE_KEY = 'cozyology.measurementReports.v1';
  var SUPPORT_EMAIL = 'mailto:design@cozyology.com';
  var CONSULTATION_URL = 'https://www.cozyology.com/products/complimentary-1-on-1-zoom-consultation';
  var installedComponents = new WeakMap();
  var activeStates = [];

  function cleanText(value) {
    return String(value || '')
      .replace(/[\u00a0\u202f]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function findSmallestTextElement(root, text) {
    if (!root || !root.querySelectorAll) return null;
    var expected = cleanText(text);
    return Array.prototype.slice.call(root.querySelectorAll('*'))
      .filter(function (node) { return cleanText(node.textContent).indexOf(expected) !== -1; })
      .sort(function (first, second) {
        return cleanText(first.textContent).length - cleanText(second.textContent).length;
      })[0] || null;
  }

  function markResultLayout(state, active) {
    Array.prototype.forEach.call(state.root.querySelectorAll(
      '[data-cz-result-sidebar], [data-cz-result-main], [data-cz-result-screenshot], [data-cz-result-native-actions], [data-cz-result-help]'
    ), function (node) {
      node.removeAttribute('data-cz-result-sidebar');
      node.removeAttribute('data-cz-result-main');
      node.removeAttribute('data-cz-result-screenshot');
      node.removeAttribute('data-cz-result-native-actions');
      node.removeAttribute('data-cz-result-help');
    });
    if (!active) {
      var compactHelp = state.root.querySelector('.cz-review-compact-help--desktop');
      if (compactHelp) compactHelp.remove();
      if (state.componentType === 'drapery' && state.container.parentNode !== state.root) state.root.appendChild(state.container);
      return;
    }

    var helpHeadings = Array.prototype.slice.call(state.root.firstElementChild.querySelectorAll('*'))
      .filter(function (node) { return cleanText(node.textContent) === 'Need quick 1-on-1 help?'; });
    helpHeadings.forEach(function (heading) {
      var block = heading;
      var found = false;
      while (block && block.parentElement) {
        block = block.parentElement;
        var classes = String(block.className || '');
        if (classes.indexOf('mt-30') !== -1 ||
          (classes.indexOf('lg:hidden') !== -1 && classes.indexOf('mt-8') !== -1)) {
          found = true;
          break;
        }
      }
      if (found && block) block.setAttribute('data-cz-result-help', '');
    });
    var help = helpHeadings[0] || null;
    var sidebarCandidates = Array.prototype.slice.call(state.root.firstElementChild.querySelectorAll('*'))
      .filter(function (node) {
        var text = cleanText(node.textContent);
        return text.indexOf('Step 1 - ') !== -1 &&
          text.indexOf('Need quick 1-on-1 help?') !== -1 &&
          cleanText(node.className).indexOf('hidden') !== -1;
      });
    var sidebar = sidebarCandidates[0] || (help && help.parentElement && help.parentElement.parentElement);
    if (sidebar) sidebar.setAttribute('data-cz-result-sidebar', '');


    var shopButtons = Array.prototype.slice.call(state.root.firstElementChild.querySelectorAll('button'))
      .filter(function (button) { return cleanText(button.textContent) === 'SHOP NOW'; });
    shopButtons.forEach(function (button) {
      if (button.parentElement) button.parentElement.setAttribute('data-cz-result-native-actions', '');
    });
    var nativeActions = shopButtons[0] && shopButtons[0].parentElement;
    // Both tools share this outer content column. Shade also has an inner flex-1 summary.
    var calculatorLayout = state.root.firstElementChild.firstElementChild;
    var resultMain = calculatorLayout && calculatorLayout.lastElementChild;
    if (resultMain && String(resultMain.className || '').split(/\s+/).indexOf('flex-1') !== -1) {
      resultMain.setAttribute('data-cz-result-main', '');
      if (state.componentType === 'drapery' && state.container.parentNode !== state.root) state.root.appendChild(state.container);
    }

    // Decorate the native result only. Its calculation, text and event handlers remain authoritative.
    var summary = nativeActions && nativeActions.parentElement;
    if (summary) {
      summary.setAttribute('data-cz-result-summary', '');
      var isShade = state.componentType === 'shade';
      state.component.setAttribute('data-cz-result-layout', isShade ? 'shade' : 'drapery');
      (isShade ? summary : summary.parentElement).setAttribute('data-cz-result-card', '');
      var title = findSmallestTextElement(summary, 'Your recommended');
      if (title) title.setAttribute('data-cz-result-title', '');
      var size = summary.querySelector('.font-americana_bt');
      if (size) size.setAttribute('data-cz-result-size', '');
      var note = findSmallestTextElement(summary, isShade ? 'Use the size listed above' : 'No further calculation needed');
      if (note) note.setAttribute('data-cz-result-note', '');
      if (!isShade && title && size && title.parentElement === size.parentElement) {
        title.parentElement.setAttribute('data-cz-result-intro', '');
      }
    }
    state.component.toggleAttribute('data-cz-result-long-size',
      Boolean(state.current && (state.current.width.length > 5 || state.current.length.length > 5)));
    if (resultMain && resultMain.parentElement) {
      Array.prototype.forEach.call(resultMain.parentElement.children, function (node) {
        if (node !== resultMain && /Step 1/.test(node.textContent)) node.setAttribute('data-cz-result-sidebar', '');
      });
    }

    var screenshot = findSmallestTextElement(state.root.firstElementChild, 'For your records, please');
    if (screenshot) screenshot.setAttribute('data-cz-result-screenshot', '');

    // Native tables remain untouched and authoritative for parsing/PDF. Both tools
    // present those inputs through the same disclosure outside the calculator DOM.
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function makeId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'report-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function readReports() {
    try {
      var value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter(function (item) {
        return item && item.id && item.measurement;
      }) : [];
    } catch (error) {
      return [];
    }
  }

  function writeReports(reports) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(reports));
      return true;
    } catch (error) {
      return false;
    }
  }

  function findDetailRows(root) {
    var selected = root && root.querySelector ? root.querySelector('.selected-data') : null;
    var rows = [];

    function addRow(label, value) {
      label = cleanText(label).replace(/:\s*$/, '');
      value = cleanText(value);
      if (!label || !value) return;
      if (rows.some(function (row) { return row.label === label; })) return;
      rows.push({ label: label, value: value });
    }

    if (selected && selected.querySelectorAll) {
      Array.prototype.forEach.call(selected.querySelectorAll('div'), function (node) {
        if (!node.children || node.children.length !== 2) return;
        var labelText = cleanText(node.children[0].textContent);
        if (!/:\s*$/.test(labelText)) return;
        addRow(labelText, node.children[1].textContent);
      });
    }

    if (root && root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('table td'), function (cell) {
        var text = cleanText(cell.textContent);
        var separator = text.indexOf(':');
        if (separator < 1) return;
        addRow(text.slice(0, separator), text.slice(separator + 1));
      });
    }

    return rows;
  }

  function rowValue(rows, pattern) {
    var row = rows.find(function (item) { return pattern.test(item.label); });
    return row ? row.value : '';
  }

  // Walk the configured route, never the visit history: going back leaves values
  // from other routes in the calculator's state. Only reachable fields belong in
  // a report. Keep field IDs so coverage can be tested independently of labels.
  function currentBranchData(snapshot, config) {
    if (!snapshot || !config || !config.measurementConfig) return null;
    var steps = config.measurementConfig;
    var choices = snapshot.choices || {};
    var inputs = snapshot.inputs || {};
    var keys = snapshot.hardwareKeys || {};
    var rows = [], visited = [], activeChoices = {};
    var stepId = 'step-1';
    var choiceLabels = {
      'step-2-0': 'Drapery Rod Installed',
      'step-2-0-0': 'Drapery Rod or Track Installed',
      'step-2-0-1': 'Hardware', 'step-2-0-2': 'Hardware',
      'step-2-2-7': 'Hardware Mount', 'step-2-2-10': 'Hardware Mount',
      'step-3-1-7': 'Hardware Visibility', 'step-3-1-8': 'Hardware Visibility',
      'step-3-1-9': 'Hardware Visibility', 'step-4-1': 'Panel',
      'step-3-1-2': 'Length Style', 'step-3-2-3': 'Length Style',
      'step-3-1-3': 'Length Style'
    };
    var inputLabels = {
      'inside-width-top': 'Window Width — Top (A)',
      'inside-width-middle': 'Window Width — Middle (B)',
      'inside-width-bottom': 'Window Width — Bottom (C)',
      'inside-height-left': 'Window Height — Left (A)',
      'inside-height-middle': 'Window Height — Middle (B)',
      'inside-height-right': 'Window Height — Right (C)',
      'outside-window-width': 'Window Width — Frame Outer Edges',
      'outside-window-height': 'Window Height — Frame Outer Edges',
      'outside-width-left-extension': 'Width Extension — Left',
      'outside-width-right-extension': 'Width Extension — Right',
      'outside-height-above-extension': 'Mounting Height Above Window',
      'ripplefold-ring-ceiling-to-bottom-height': 'Ceiling-to-Drapery Distance',
      'ripplefold-how-to-hardware-height': 'Hardware-to-Drapery Distance'
    };
    function label(text) { return cleanText(text).replace(/\?/g, ''); }
    function title(text) { return cleanText(text).toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }); }
    function add(id, name, value) { rows.push({ id: id, label: name, value: value }); }
    while (stepId && visited.indexOf(stepId) === -1) {
      visited.push(stepId);
      var step = steps[stepId];
      if (!step) return null;
      if (step.type === 'finished') {
        if (snapshot.step !== stepId) return null;
        return { rows: rows, choices: activeChoices, steps: visited };
      }
      if (step.type === 'select') {
        var selected = step.options.find(function (option) { return option.id === choices[stepId]; });
        if (!selected) return null;
        activeChoices[stepId] = selected.id;
        // Step 4 card copy can change without renaming the saved report selection.
        var selectedTitle = snapshot.type === 'drapery' && stepId === 'step-4-1' ?
          ({ 'single-panels': 'Single', 'split-panels': 'Split' }[selected.id] || title(selected.title)) : title(selected.title);
        add(stepId, stepId === 'step-1' ? (snapshot.type === 'drapery' ? 'Header' : 'Mount Style') :
          choiceLabels[stepId] || label(step.title), selectedTitle);
        stepId = selected.jump;
      } else if (step.type === 'input') {
        for (var index = 0; index < step.options.length; index += 1) {
          var option = step.options[index];
          var value = inputs[option.id];
          // 0 is valid for extensions and customer hardware heights.
          if (value === undefined || value === null || String(value).trim() === '') return null;
          var fieldLabel = inputLabels[option.id] || label(step.title);
          if (step.options.length > 1 && !inputLabels[option.id]) fieldLabel += ' — ' + label(option.label || option.title);
          if (option.isTrackSelector || option.isSingleSelector) {
            var hardwareKey = keys[option.id];
            var header = activeChoices['step-1'];
            var mount = activeChoices[header === 'ripple-fold' ? 'step-2-2-10' : 'step-2-2-7'];
            var groups = config[option.isSingleSelector ? 'trackSelectorSingleOptions' : 'trackSelectorOptions'] || {};
            var models = (groups[header] || {})[/ceiling/.test(mount) ? 'ceiling' : 'wall'] || [];
            var model = hardwareKey ? models[Number(hardwareKey) - 1] : null;
            // A selected model must resolve by its key, not by height: models can
            // share a height. Never silently label an unknown model as My Hardware.
            if ((hardwareKey || option.isSingleSelector) && !model) return null;
            add(option.id + ':source', 'Hardware Source', model ? 'Cozyology Hardware' : 'My Hardware');
            if (model) add(option.id + ':model', 'Hardware Model', cleanText(model.label));
          }
          var inputDisplay = snapshot.inputDisplay && snapshot.inputDisplay[option.id];
          var parsedDisplay = window.CozyologyMeasurementInput && window.CozyologyMeasurementInput.parse(inputDisplay);
          var savedDisplay = !option.isTrackSelector && !option.isSingleSelector && parsedDisplay && parsedDisplay.isValid && parsedDisplay.numericValue === value ? parsedDisplay.display : null;
          add(option.id, fieldLabel, savedDisplay != null ? savedDisplay + '"' : (typeof value === 'number' && window.CozyologyMeasurementInput ? window.CozyologyMeasurementInput.format(value) : String(value).trim()) + '"');
        }
        stepId = step.jump;
      } else return null;
    }
    return null;
  }

  function parseReportData(root, componentType, snapshot, config) {
    if (!root) return null;
    if (snapshot && snapshot.type !== componentType) return null;
    var text = cleanText(root.textContent);
    if (!/Your recommended (?:(?:Single Panel Order|Total Coverage) Size|shade size) is/i.test(text)) return null;

    var size = text.match(
      /(\d+(?:\.\d+)?(?:\s+\d+\s*\/\s*\d+)?)\s*["”]?\s*W\s*[×xX]\s*(\d+(?:\.\d+)?(?:\s+\d+\s*\/\s*\d+)?)\s*["”]?\s*L/i
    );
    if (!size) return null;

    var branch = snapshot ? currentBranchData(snapshot, config) : null;
    if (snapshot && !branch) return null;
    var rows = branch ? branch.rows : findDetailRows(root);
    var headerMatch = text.match(/Header:\s*(Pleated|Ripple\s*Fold|Soft\s*Top|Grommet)/i);
    var fullnessMatch = text.match(/(?:Pre-set Built-in )?Fullness:\s*([\d.]+x)/i);
    var quantityMatch = text.match(/Quantity:\s*(\d+(?:\s+panels?)?)/i);
    var hardwareMatch = text.match(/Hardware:\s*(Rod|Track)/i);
    var type = componentType === 'drapery' ? 'drapery' : 'shade';
    // The current native calculator already applies Single/Split to its width,
    // including Ripple Fold (whose legacy heading still says Total Coverage).
    // Preserve that authoritative per-panel result; never divide it a second time.
    var orderKind = type === 'drapery' ? 'Recommended single-panel order size' : 'Recommended shade order size';
    var width = cleanText(size[1]);

    return {
      measurementType: type,
      width: width,
      length: cleanText(size[2]),
      orderKind: orderKind,
      header: branch ? rowValue(rows, /^Header$/) : headerMatch ? cleanText(headerMatch[1]) : '',
      fullness: fullnessMatch ? cleanText(fullnessMatch[1]) + ' built in' : '',
      quantity: quantityMatch ? cleanText(quantityMatch[1]) : '',
      hardware: branch ? rowValue(rows, /^Hardware$/) : hardwareMatch ? cleanText(hardwareMatch[1]) : '',
      installation: rowValue(rows, /^(?:Hardware|Mount Style)$/i),
      rodTrackLength: rowValue(rows, /^(?:Rod|Track|Hardware) Length$/i),
      measurementHeight: rowValue(rows, /(?:Floor|Height)$/i),
      measurementHeightLabel: (rows.find(function (item) {
        return /(?:Floor|Height)$/i.test(item.label);
      }) || {}).label || '',
      panelLayout: rowValue(rows, /^Panel$/i),
      lengthStyle: rowValue(rows, /^Length Style$/i),
      inputRows: rows
    };
  }

  function defaultProductType(componentType) {
    return componentType === 'drapery' ? 'Drapery' : 'Shade';
  }

  function defaultDraft(componentType, reports) {
    return {
      roomName: '',
      email: '',
      windowNumber: '',
      productType: defaultProductType(componentType)
    };
  }

  function reportSignature(report) {
    if (!report) return '';
    return JSON.stringify({
      measurementType: report.measurementType,
      width: report.width,
      length: report.length,
      header: report.header,
      fullness: report.fullness,
      quantity: report.quantity,
      orderKind: report.orderKind,
      installation: report.installation,
      panelLayout: report.panelLayout,
      lengthStyle: report.lengthStyle,
      inputRows: report.inputRows
    });
  }

  function saveDialogHtml(state) {
    if (!state.saveDialogOpen) return '';
    var downloading = state.dialogMode === 'download';
    var emailing = state.dialogMode === 'email';
    var disabled = state.downloadBusy ? ' disabled' : '';
    return '<dialog class="cz-measure-report__modal" data-report-dialog-backdrop aria-labelledby="cz-save-report-title">' +
      '<section class="cz-measure-report__dialog">' +
      '<button class="cz-measure-report__close" type="button" data-report-action="cancel-save" aria-label="Close"' + disabled + '>×</button>' +
      '<h2 id="cz-save-report-title">' + (emailing ? 'Email your report' : downloading ? 'Download your report' : 'Save your report') + '</h2>' +
      '<p>Add a name to organize your report, or leave these fields blank.</p>' +
      '<form data-report-form novalidate>' +
      '<label><span>Room name (optional)</span><input name="roomName" data-report-field="roomName" maxlength="60" autocomplete="off" value="' + escapeHtml(state.draft.roomName) + '"' + disabled + '></label>' +
      '<label><span>Window name / number (optional)</span><input name="windowNumber" data-report-field="windowNumber" maxlength="20" autocomplete="off" value="' + escapeHtml(state.draft.windowNumber) + '"' + disabled + '></label>' +
      (emailing ? '<label><span>Your email</span><input name="email" type="email" inputmode="email" data-report-field="email" required maxlength="254" autocomplete="email" autocapitalize="none" spellcheck="false" value="' + escapeHtml(state.draft.email) + '"' + disabled + '></label><p class="cz-measure-report__dialog-status">' +
        (state.component.hasAttribute('data-report-email-preview') ? 'Local test only — no email will be sent.' : 'Used to send this report, not to sign you up for marketing.') + '</p>' : '') +
      '<p class="cz-measure-report__dialog-status" role="status">' + escapeHtml(state.dialogNotice || '') + '</p>' +
      '<div class="cz-measure-report__dialog-actions">' +
      '<button type="button" class="cz-button cz-button--secondary" data-report-action="cancel-save"' + disabled + '>CANCEL</button>' +
      '<button type="submit" class="cz-button cz-button--primary"' + disabled + '>' + (state.downloadBusy ? (emailing ? 'PREPARING EMAIL…' : 'PREPARING PDF…') : emailing ? 'EMAIL REPORT' : downloading ? 'DOWNLOAD PDF' : 'SAVE REPORT') + '</button>' +
      '</div></form></section></dialog>';
  }

  function fullnessDescription(measurement) {
    if (measurement.measurementType !== 'drapery' || !measurement.header) return null;
    return {
      summary: 'Fullness included (approx. 2–2.5×)',
      value: 'Approx. 2–2.5×, depending on header style; already included',
      note: 'Based on 30 years of drapery experience, we choose the fullness to suit your header style. It’s already included in your order size.'
    };
  }

  function fabricUsage(measurement) {
    // A customer-facing estimate, not a cutting specification or order-size
    // multiplier. Exact header coefficients are not yet configured; the approved
    // temporary range is applied to the native single-panel order width.
    if (measurement.measurementType !== 'drapery' ||
      !/^(Pleated|Ripple Fold|Soft Top|Grommet)$/i.test(measurement.header || '') ||
      measurement.orderKind !== 'Recommended single-panel order size') return null;
    var widthText = cleanText(measurement.width);
    var decimal = widthText.match(/^\d+(?:\.\d+)?$/);
    var fraction = widthText.match(/^(?:(\d+)\s+)?(\d+)\s*\/\s*(\d+)$/);
    var width = decimal ? Number(widthText) : fraction && Number(fraction[3]) > 0 ?
      Number(fraction[1] || 0) + Number(fraction[2]) / Number(fraction[3]) : NaN;
    var count = cleanText(measurement.quantity).match(/^([12])(?:\s+panels?)?$/i);
    if (!Number.isFinite(width) || width <= 0 || !count) return null;
    var panels = Number(count[1]);
    function format(value) { return String(Number(value.toFixed(3))); }
    function range(value) { return format(value * 2) + '–' + format(value * 2.5); }
    return {
      width: widthText,
      header: measurement.header,
      panels: panels,
      coverage: panels === 1 ?
        'This panel covers ' + widthText + '″ of your rod or track when closed.' :
        'Each panel covers ' + widthText + '″ of your rod or track when closed. Two panels provide ' + format(width * panels) + '″ of coverage.',
      perPanel: range(width),
      total: range(width * panels),
      equation: widthText + '″ × (2–2.5) ≈ ' + range(width) + '″ per panel',
      totalText: 'Approx. ' + range(width * panels) + '″ across ' + panels + ' panels',
      definition: 'The approximate width of one panel’s bottom hem when fully spread flat—not its hanging coverage or order width.',
      // Abby confirmed 5–10 inches for EACH panel, not the pair or rod total.
      // Explanatory manufacturing allowance only; never adjust order dimensions.
      springBack: 'Each panel’s fully stretched header is approx. 5–10″ wider than its single-panel order width. This allows for spring-back and overlap to help reduce light gaps.',
      springBackOrder: 'Already included—do not add extra width.',
      note: 'Extra fabric creates the folds. Order ' + widthText +
        '″ per panel—fullness is already included.'
    };
  }

  function fabricUsageRows(measurement) {
    var usage = fabricUsage(measurement);
    if (!usage) return [];
    var rows = [{ label: 'Estimated fabric width (flat hem)', value: usage.equation },
      { label: 'What this width means', value: usage.definition }];
    if (usage.panels > 1) rows.push({ label: 'Total estimated fabric width', value: usage.totalText });
    rows.push({ label: 'Fabric width note', value: usage.note });
    rows.push({ label: 'Header stretch allowance', value: usage.springBack + ' ' + usage.springBackOrder });
    return rows;
  }

  function orderInformationHtml(measurement, compact) {
    var fields = [];
    var isDrapery = measurement.measurementType === 'drapery';
    if (isDrapery) {
      if (measurement.header) fields.push({ label: 'Header Style', value: measurement.header });
      if (measurement.quantity) fields.push({ label: 'Order quantity', value: measurement.quantity, quantity: true });
    } else if (measurement.installation) {
      fields.push({ label: 'Installation Method', value: measurement.installation });
    }
    var html = '<section class="cz-measure-report__order' + (isDrapery ? ' cz-measure-report__order--drapery' : '') + '" aria-label="Your order details"><dl>' +
      fields.map(function (field) {
        return '<div' + (field.quantity ? ' class="cz-measure-report__quantity"' : '') + '><dt>' + escapeHtml(field.label) + '</dt><dd>' + escapeHtml(field.value) + '</dd></div>';
      }).join('') + '</dl>';
    if (!compact && isDrapery && measurement.orderKind === 'Recommended single-panel order size') {
      html += '<p class="cz-measure-report__order-note">Width shown is per panel.</p>';
    }
    return html + '</section>';
  }

  function fabricDiagramUrl(component) {
    var styleUrl = component && component.getAttribute('data-report-style-url');
    if (!styleUrl) return '';
    return new window.URL('cozyology-panel-order-width.webp', new window.URL(styleUrl, document.baseURI)).href;
  }

  function fabricDiagramHtml(usage, illustrationUrl) {
    var url = flatWidthDiagramUrl(illustrationUrl, usage);
    if (!usage || !url) return '';
    return '<figure class="cz-measure-report__hem-diagram">' +
      '<img src="' + escapeHtml(url) + '" width="320" height="340" loading="lazy" alt="One complete curtain with its sewn header gathered and bottom hem spread flat. Only the bottom arrow shows estimated flat hem width; the header is not measured. Illustration only. Not shown hanging.">' +
      '<figcaption class="cz-measure-report__diagram-caption"><span>Flat hem width per panel</span><strong>Approx. ' + escapeHtml(usage.perPanel) + '″</strong><span>Bottom hem spread flat · Illustration only</span><span>' + escapeHtml(usage.width) + '″ × 2–2.5 fullness</span></figcaption></figure>';
  }

  function diagramHeader(measurement) {
    return { pleated: 'pleated', 'ripple fold': 'ripple', 'soft top': 'soft-top', grommet: 'grommet' }[cleanText(measurement.header).toLowerCase()] || 'generic';
  }

  function diagramPanelCount(measurement) {
    var count = cleanText(measurement.quantity).match(/^([12])(?:\s+panels?)?$/i);
    return count ? Number(count[1]) : /^split$/i.test(cleanText(measurement.panelLayout)) ? 2 : 1;
  }

  function flatWidthDiagramUrl(illustrationUrl, measurement) {
    if (!illustrationUrl || !measurement) return '';
    return new window.URL('cz-review-flat-' + diagramHeader(measurement) + '.webp', illustrationUrl).href;
  }

  function orderDiagramUrl(measurement, illustrationUrl) {
    if (!measurement || !illustrationUrl) return '';
    var file = measurement.measurementType === 'shade' ? 'cz-review-order-shade-' +
      (/outside/i.test(measurement.installation) ? 'outside' : 'inside') +
      (/puddles/i.test(measurement.lengthStyle || '') ? '-puddles' : '') + '.svg' :
      'cz-review-order-' + diagramHeader(measurement) + '-' + diagramPanelCount(measurement) + '.svg';
    var url = new window.URL(file, illustrationUrl);
    // These SVGs are resolved relative to another asset, so Shopify's asset_url
    // version is absent. Invalidate cached artwork when the shared diagram changes.
    url.searchParams.set('v', '20260919-input-style-1');
    return url.href;
  }

  function orderDiagramLabels(measurement) {
    var total = measurement.orderKind === 'Total coverage order size';
    return {
      width: total ? 'Total coverage width' : measurement.measurementType === 'drapery' ? 'Order width per panel' : 'Order width',
      note: total ? 'Total coverage size, not per-panel width. Illustration only.' :
        measurement.measurementType === 'drapery' ? 'Size shown is per panel. Style shown for illustration only.' :
        'Finished shade order size. Style shown for illustration only.'
    };
  }

  function orderSizeDiagramHtml(measurement, illustrationUrl, compact) {
    var url = orderDiagramUrl(measurement, illustrationUrl);
    if (!url) return '';
    var drapery = measurement.measurementType === 'drapery', pair = drapery && diagramPanelCount(measurement) === 2;
    var shadeClass = drapery ? '' : ' cz-review-drawing--shade cz-review-drawing--shade-' + (/outside/i.test(measurement.installation) ? 'outside' : 'inside');
    return '<figure class="cz-review-diagram" aria-label="Order size illustration"><div class="cz-review-drawing' + (pair ? ' cz-review-drawing--pair' : '') + (drapery && diagramHeader(measurement) === 'soft-top' ? ' cz-review-drawing--soft-top' : '') + shadeClass + '">' +
      '<img src="' + escapeHtml(url) + '" alt="' + escapeHtml(drapery ? measurement.header + ', ' + diagramPanelCount(measurement) + ' panel(s), shown closed' : measurement.installation + ' shade, ' + (measurement.lengthStyle || 'Breaks on Window Frame')) + '" width="320" height="' + (drapery ? '320' : '340') + '">' +
      '<div class="cz-review-width"><span>' + escapeHtml(measurement.width) + '″' + (drapery ? ' per panel' : '') + '</span></div>' +
      '<div class="cz-review-length"><span>' + escapeHtml(measurement.length) + '″</span></div></div>' +
      '<figcaption>Illustration only · Not to scale</figcaption></figure>';
  }

  function insideMountWidthNote(measurement, html) {
    var instruction = 'No further deduction needed.';
    return measurement.measurementType === 'shade' && /^inside mount$/i.test(cleanText(measurement.installation)) ?
      'Width reduced by 3/8″ for installation clearance. ' + (html ? '<strong>' + instruction + '</strong>' : instruction) : '';
  }

  function orderOverviewHtml(measurement, illustrationUrl) {
    var total = measurement.orderKind === 'Total coverage order size';
    var drapery = measurement.measurementType === 'drapery';
    var title = total ? 'Your total coverage size' : drapery ? (diagramPanelCount(measurement) === 2 ? 'Order each panel at' : 'Order your panel at') : 'Your shade order size';
    return '<section class="cz-measure-report__overview' + (drapery ? ' cz-measure-report__overview--drapery' : '') + '" aria-label="Your order summary">' +
      '<div class="cz-measure-report__overview-info"><h2>' + title + '</h2>' +
      '<p class="cz-measure-report__overview-size"><span>' + escapeHtml(measurement.width) + '″<small> W</small></span>' +
      '<span class="cz-measure-report__size-times" aria-hidden="true">×</span><span>' + escapeHtml(measurement.length) + '″<small> L</small></span></p>' +
      orderInformationHtml(measurement, drapery) +
      (drapery || insideMountWidthNote(measurement) ? '' : '<p class="cz-measure-report__overview-note">' +
      (total ? 'Use this total coverage size when ordering.' : 'Order the size shown—no further calculation needed.') + '</p>') + '</div>' + orderSizeDiagramHtml(measurement, illustrationUrl, drapery) + '</section>';
  }

  function installationAllowanceHtml(measurement, open) {
    if (!insideMountWidthNote(measurement)) return '';
    return '<details class="cz-measure-report__fabric"' + (open ? ' open' : '') + '><summary>Installation allowance included</summary>' +
      '<div class="cz-measure-report__fabric-content"><p>The recommended width already includes a 3/8″ installation allowance. Do not deduct it again.</p></div></details>';
  }

  function fabricUsageHtml(measurement, open, illustrationUrl) {
    var usage = fabricUsage(measurement);
    if (!usage) return '';
    return '<details class="cz-measure-report__fabric"' + (open ? ' open' : '') + '><summary>Fullness included · Approx. 2–2.5×</summary>' +
      '<div class="cz-review-fullness"><figure><img src="' + escapeHtml(flatWidthDiagramUrl(illustrationUrl, measurement)) + '" width="320" height="320" alt="' + escapeHtml(measurement.header) + ' panel with the bottom hem spread flat"><svg class="cz-review-flat-width" viewBox="0 0 320 76" role="img" aria-label="Fabric width from left edge to right edge, approximately ' + escapeHtml(usage.perPanel) + ' inches"><path d="M8 0V30 M312 0V30 M8 22H312 M16 18L8 22L16 26 M304 18L312 22L304 26" fill="none" stroke="currentColor" stroke-width="1.5"/><text x="160" y="56" text-anchor="middle">Approx. ' + escapeHtml(usage.perPanel) + '″</text></svg><figcaption>Fabric laid flat · Illustration only</figcaption></figure>' +
      '<div><p>Fabric width per panel, laid flat</p><strong>Approx. ' + escapeHtml(usage.perPanel) + '″</strong><p>' + escapeHtml(usage.width) + '″ × 2–2.5 fullness</p><p>For reference only—not your order width. Fullness is already included.</p></div>' +
      '<details class="cz-review-allowance"><summary>About spring-back &amp; overlap</summary><p>' + escapeHtml(usage.springBack) + '</p><p><strong>' + escapeHtml(usage.springBackOrder) + '</strong></p></details></div></details>';
  }

  function measurementDetailGroups(measurement) {
    var groups = [
      { title: 'Your selections', rows: [] },
      { title: 'Width measurements', rows: [] },
      { title: 'Height measurements', rows: [] },
      { title: 'Installation & hardware measurements', rows: [] }
    ];
    (measurement.inputRows || []).forEach(function (row) {
      if (/^(Header|Quantity|(?:Pre-set Built-in )?Fullness)$/i.test(row.label)) return;
      var id = row.id || '';
      var index = 0;
      if (/:source$|:model$/.test(id) || /^step-/.test(id)) index = 0;
      else if (/^(track-ring-ceiling-to-bottom-height(?:-2)?|ripplefold-ring-ceiling-to-bottom-height|ripplefold-how-to-hardware-height)$/.test(id) || /depth/i.test(id)) index = 3;
      else if (/width|hardware-track-length/.test(id)) index = 1;
      else if (/height|above-frame/.test(id)) index = 2;
      // Legacy saved reports may contain labels without input IDs.
      else if (/depth|hardware height|ceiling.*bottom of hardware|hardware-to-drapery|ceiling-to-drapery/i.test(row.label)) index = 3;
      else if (/width|rod length|track length|hardware length/i.test(row.label)) index = 1;
      else if (/height|above frame|above window/i.test(row.label)) index = 2;
      groups[index].rows.push(row);
    });
    return groups.filter(function (group) { return group.rows.length; });
  }

  function measurementsHtml(measurement, open) {
    var groups = measurementDetailGroups(measurement);
    if (!groups.length) return '';
    return '<details class="cz-measure-report__measurements"' + (open === false ? '' : ' open') +
      '><summary>Your selections &amp; measurements</summary><div class="cz-measure-detail-groups">' +
      groups.map(function (group) {
        return '<section class="cz-measure-detail-group"><h3>' + escapeHtml(group.title) + '</h3><dl>' +
          group.rows.map(function (row) {
            return '<div><dt>' + escapeHtml(row.label) + '</dt><dd>' + escapeHtml(row.value) + '</dd></div>';
          }).join('') + '</dl></section>';
      }).join('') + '</div></details>';
  }

  // Full report details remain available to the page and the Shade export.
  // Drapery PDF copy is selected separately by pdfDetailRows below.
  function reportDetailRows(measurement) {
    var rows = (measurement.inputRows || []).filter(function (row) {
      return !/^(Quantity|(?:Pre-set Built-in )?Fullness)$/i.test(row.label);
    }).slice();
    var widthNote = insideMountWidthNote(measurement);
    if (widthNote) rows.push({label: 'Inside mount width allowance', value: widthNote});
    if (measurement.header && !rows.some(function (row) { return /^Header$/i.test(row.label); })) {
      rows.push({ label: 'Header', value: measurement.header });
    }
    var usage = fabricUsage(measurement);
    if (usage) rows.push({ label: 'Panel coverage', value: usage.coverage });
    var fullness = fullnessDescription(measurement);
    if (fullness) {
      rows.push({ label: 'Fullness', value: fullness.value });
      rows.push({ label: 'Fullness note', value: fullness.note });
    }
    return rows.concat(fabricUsageRows(measurement), rippleRows(measurement));
  }

  // Export-only copy: keep original inputs and concise ordering guidance.
  // The webpage continues to use the full explanations above.
  function pdfDetailRows(measurement) {
    if (measurement.measurementType !== 'drapery') return reportDetailRows(measurement);
    var rows = (measurement.inputRows || []).filter(function (row) {
      return !/^(Quantity|(?:Pre-set Built-in )?Fullness)$/i.test(row.label);
    }).slice();
    if (measurement.header && !rows.some(function (row) { return /^Header$/i.test(row.label); })) {
      rows.push({ label: 'Header', value: measurement.header });
    }
    var usage = fabricUsage(measurement);
    if (usage) {
      rows.push({ label: 'Estimated flat fabric width per panel', value: 'Approx. ' + usage.perPanel + '″ at the fully spread bottom hem; not the order width.' });
      rows.push({ label: 'Ordering reminder', value: 'Fullness and header allowance are already included. Do not add extra width.' });
    } else {
      var fullness = fullnessDescription(measurement);
      if (fullness) rows.push({ label: 'Fullness', value: fullness.value + '. Do not add extra width.' });
    }
    return rows;
  }

  function rippleRows(measurement) {
    // Hide estimated ripple/hook counts until the product specification is confirmed.
    return [];
  }

  function rippleHtml(measurement) {
    var rows = rippleRows(measurement);
    return rows.length ? '<details class="cz-measure-report__measurements"><summary>Ripple Fold · Ripples &amp; Hooks</summary><dl>' + rows.map(function(row){return '<div><dt>'+escapeHtml(row.label)+'</dt><dd>'+escapeHtml(row.value)+'</dd></div>';}).join('') + '</dl></details>' : '';
  }

  function shopUrl(state) {
    var api = window.CozyologyMeasurementTransfer, measurement = state.current;
    if (!api || !measurement) return '';
    var width = api.splitMeasurement(measurement.width), length = api.splitMeasurement(measurement.length);
    if (!width || !length) return '';
    var config = measurement.measurementType === 'drapery' ? window.CozyologyConfig_Drapery : window.CozyologyConfig;
    var destination = (config && config.shopNowUrl) || (measurement.measurementType === 'drapery' ? '/collections/all?filter.p.m.custom.product_type=Drapery' : '/collections/shades');
    var url = api.addMeasurementToUrl(destination, {type:measurement.measurementType,
      header:cleanText(measurement.header).toLowerCase().replace(/\s+/g,'-'),
      width:width.whole,widthFraction:width.fraction,length:length.whole,lengthFraction:length.fraction,
      quantity:String(diagramPanelCount(measurement))});
    return url;
  }

  function reportHelpHtml() {
    return '<section class="cz-review-help cz-review-help--centered"><h2>Need a hand?</h2>' +
      '<p>Review your measurements with us in a free 1-on-1 consultation.</p>' +
      '<div class="cz-review-help-actions"><a class="cz-button cz-button--secondary" href="' + CONSULTATION_URL + '" target="_blank" rel="noopener">Book free Zoom</a>' +
      '<a class="cz-button cz-button--secondary" href="' + SUPPORT_EMAIL + '">Email us</a></div></section>';
  }

  function reportHtml(state) {
      return '<section class="cz-page cz-measure-report cz-measure-review-layout" aria-label="Measurement report">' +
        '<div class="cz-measure-report__shell"><div class="cz-review-columns"><div class="cz-review-report">' +
        orderOverviewHtml(state.current, fabricDiagramUrl(state.component)) +
        '<div class="cz-review-primary-actions"><a class="cz-button cz-button--primary" href="' + escapeHtml(shopUrl(state)) + '">SHOP NOW</a>' +
        '<button class="cz-button cz-button--secondary" type="button" data-report-action="download">Download PDF</button>' +
        '<button class="cz-measure-report__text-action" type="button" data-report-action="calculate">Calculate again</button></div>' +
        '<p class="cz-measure-report__notice" role="status">' + escapeHtml(state.notice || '') + '</p>' + preparedReportHtml(state) +
        fabricUsageHtml(state.current, state.fabricOpen, fabricDiagramUrl(state.component)) +
        installationAllowanceHtml(state.current, state.fabricOpen) +
        rippleHtml(state.current) + measurementsHtml(state.current, state.measurementsOpen) +
        reportHelpHtml() +
        '</div></div></div>' + saveDialogHtml(state) + '</section>';

  }

  function createState(component, root, container) {
    var type = component.getAttribute('type') === 'drapery' ? 'drapery' : 'shade';
    var reports = readReports();
    return {
      component: component,
      root: root,
      container: container,
      componentType: type,
      reports: reports,
      current: null,
      currentSignature: '',
      recordId: '',
      draft: defaultDraft(type, reports),
      saveDialogOpen: false,
      dialogMode: 'save',
      dialogNotice: '',
      downloadBusy: false,
      preparedReport: null,
      emailAttempt: null,
      notice: '',
      measurementsOpen: true,
      fabricOpen: false,
      renderKey: ''
    };
  }

  function render(state, force) {
    var active = Boolean(state.current);
    var key = JSON.stringify({
      active: active,
      current: state.currentSignature,
      draft: state.draft,
      recordId: state.recordId,
      saveDialogOpen: state.saveDialogOpen,
      dialogMode: state.dialogMode,
      dialogNotice: state.dialogNotice,
      downloadBusy: state.downloadBusy,
      preparedReport: state.preparedReport && state.preparedReport.url,
      notice: state.notice,
      reports: state.reports.map(function (item) { return [item.id, item.savedAt]; })
    });
    if (!force && key === state.renderKey) return;
    state.renderKey = key;
    state.component.toggleAttribute('data-cz-measurement-report-active', active);
    state.component.toggleAttribute('data-cz-compact-result', active);
    markResultLayout(state, active);
    state.container.innerHTML = active ? reportHtml(state) : '';
    var modal = state.container.querySelector('.cz-measure-report__modal');
    if (modal && !modal.open) {
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
    }
  }

  function syncLiveResult(state) {
    var snapshot = state.component.czMeasurementState;
    var config = state.componentType === 'drapery' ? window.CozyologyConfig_Drapery : window.CozyologyConfig;
    var live = snapshot ? parseReportData(state.root.firstElementChild, state.componentType, snapshot, config) : null;
    if (!live) {
      if (state.current) {
        releasePreparedReport(state);
        state.current = null;
        state.currentSignature = '';
        state.recordId = '';
        state.saveDialogOpen = false;
        state.notice = '';
      }
      render(state);
      return;
    }

    var signature = reportSignature(live);
    if (signature !== state.currentSignature) {
      releasePreparedReport(state);
      state.current = live;
      state.currentSignature = signature;
      state.recordId = '';
      state.saveDialogOpen = false;
      state.draft = defaultDraft(state.componentType, state.reports);
      state.notice = '';
      state.measurementsOpen = true;
      state.fabricOpen = false;
    }
    render(state);
  }

  function fieldValue(state, name, value) {
    if (!Object.prototype.hasOwnProperty.call(state.draft, name)) return;
    state.draft[name] = cleanText(value);
  }

  function validateDraft(state) {
    var form = state.container.querySelector('[data-report-form]');
    if (form) {
      ['roomName', 'windowNumber'].forEach(function (field) {
        var input = form.querySelector('[name="' + field + '"]');
        if (input && input.setCustomValidity) input.setCustomValidity('');
      });
      if (state.dialogMode === 'email') {
        var emailInput = form.querySelector('[name="email"]');
        if (emailInput && emailInput.setCustomValidity) emailInput.setCustomValidity(
          /^[^\s@,;<>]+@[^\s@,;<>]+\.[^\s@,;<>]+$/.test(cleanText(emailInput.value)) ? '' : 'Please enter a valid email address.');
      }
    }
    if (form && typeof form.reportValidity === 'function' && !form.reportValidity()) return false;
    return Boolean(state.draft.productType);
  }

  function openSaveDialog(state, mode) {
    state.saveDialogOpen = true;
    state.dialogMode = mode || 'save';
    state.dialogNotice = '';
    state.notice = '';
    render(state, true);
    window.requestAnimationFrame(function () {
      var input = state.container.querySelector('[data-report-field="roomName"]');
      if (input && typeof input.focus === 'function') input.focus();
    });
  }

  function closeSaveDialog(state) {
    if (state.downloadBusy) return;
    state.saveDialogOpen = false;
    render(state, true);
    var action = state.container.querySelector('[data-report-action="' + (state.dialogMode === 'email' ? 'email' : 'download') + '"]');
    if (action) action.focus();
  }

  function saveCurrent(state) {
    if (!state.current || !validateDraft(state)) return;
    var now = new Date().toISOString();
    var id = state.recordId || makeId();
    var record = {
      id: id,
      roomName: state.draft.roomName,
      windowNumber: state.draft.windowNumber,
      productType: state.draft.productType,
      measurement: state.current,
      savedAt: now,
      storage: 'browser-local'
    };
    var reports = state.reports.filter(function (item) { return item.id !== id; });
    reports.unshift(record);
    if (!writeReports(reports)) {
      state.notice = 'This browser blocked saving. Please download the report instead.';
      state.saveDialogOpen = false;
      render(state, true);
      return;
    }
    state.reports = reports;
    state.recordId = id;
    state.saveDialogOpen = false;
    state.notice = 'Report saved on this device. Customer account sync is not connected yet.';
    render(state, true);
  }

  function pdfSafe(value) {
    return cleanText(value)
      .replace(/[“”]/g, '"')
      .replace(/[‘’]/g, "'")
      .replace(/×/g, 'x')
      .replace(/–|—/g, '-')
      .replace(/[^\x20-\x7e]/g, '')
      .replace(/\\/g, '\\\\')
      .replace(/\(/g, '\\(')
      .replace(/\)/g, '\\)');
  }

  function wrapPdfText(value, limit) {
    var words = cleanText(value).split(' ');
    var lines = [];
    var line = '';
    words.forEach(function (word) {
      var next = line ? line + ' ' + word : word;
      if (next.length > limit && line) {
        lines.push(line);
        line = word;
      } else {
        line = next;
      }
    });
    if (line) lines.push(line);
    return lines;
  }

  function pdfReportLines(measurement, metadata) {
    var product = metadata && metadata.productType ? metadata.productType : defaultProductType(measurement.measurementType);
    var lines = [
      { text: 'Cozyology Measurement Report', font: 'F2', size: 21, gap: 32 },
      { text: product + ' measurement', font: 'F2', size: 14, gap: 22 },
      { text: measurement.orderKind + ': ' + measurement.width + '" W x ' + measurement.length + '" L', font: 'F2', size: 12, gap: 19 }
    ];
    if (measurement.quantity) lines.push({ text: 'Order quantity: ' + measurement.quantity, font: 'F1', size: 14, gap: 20 });
    if (metadata && metadata.roomName) lines.push({ text: 'Room: ' + metadata.roomName, font: 'F1', size: 11, gap: 16 });
    if (metadata && metadata.windowNumber) lines.push({ text: 'Window: ' + metadata.windowNumber, font: 'F1', size: 11, gap: 16 });
    lines.push({ text: 'Measurement details', font: 'F2', size: 13, gap: 22 });

    var seen = {};
    function addDetail(label, value) {
      label = cleanText(label);
      value = cleanText(value);
      if (!label || !value || seen[label.toLowerCase()]) return;
      seen[label.toLowerCase()] = true;
      wrapPdfText(label + ': ' + value, 78).forEach(function (text) {
        lines.push({ text: text, font: 'F1', size: 11, gap: 16 });
      });
    }
    pdfDetailRows(measurement).forEach(function (row) { addDetail(row.label, row.value); });
    lines.push({ text: 'Please double-check every measurement before ordering.', font: 'F1', size: 10, gap: 18 });
    return lines;
  }

  function buildPdf(measurement, metadata, artwork) {
    if (!measurement) return new Uint8Array(0);
    if (artwork && artwork.length) return buildIllustratedPdf(artwork, metadata);
    var y = 738;
    var commands = [];
    pdfReportLines(measurement, metadata || {}).forEach(function (line) {
      if (y < 54) return;
      commands.push('BT /' + line.font + ' ' + line.size + ' Tf 54 ' + y + ' Td (' + pdfSafe(line.text) + ') Tj ET');
      y -= line.gap;
    });
    var stream = commands.join('\n') + '\n';
    var objects = [
      '<< /Type /Catalog /Pages 2 0 R >>',
      '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
      '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] /Resources << /Font << /F1 4 0 R /F2 5 0 R >> >> /Contents 6 0 R >>',
      '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>',
      '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold >>',
      '<< /Length ' + stream.length + ' >>\nstream\n' + stream + 'endstream'
    ];
    var pdf = '%PDF-1.4\n';
    var offsets = [0];
    objects.forEach(function (object, index) {
      offsets.push(pdf.length);
      pdf += (index + 1) + ' 0 obj\n' + object + '\nendobj\n';
    });
    var xref = pdf.length;
    pdf += 'xref\n0 ' + (objects.length + 1) + '\n0000000000 65535 f \n';
    offsets.slice(1).forEach(function (offset) {
      pdf += String(offset).padStart(10, '0') + ' 00000 n \n';
    });
    pdf += 'trailer\n<< /Size ' + (objects.length + 1) + ' /Root 1 0 R >>\nstartxref\n' + xref + '\n%%EOF';
    var bytes = new Uint8Array(pdf.length);
    for (var index = 0; index < pdf.length; index += 1) bytes[index] = pdf.charCodeAt(index) & 255;
    return bytes;
  }

  function buildIllustratedPdf(pages, metadata) {
    // High-resolution artwork preserves the storefront fonts and customer-entered
    // Unicode. An invisible text layer also makes Latin measurement text searchable.
    var objects = [null, null, '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>'];
    var pageIds = [];
    pages.forEach(function (page) {
      var pageId = objects.length + 1;
      var imageId = pageId + 1;
      var contentId = pageId + 2;
      var links = page.links || [];
      var annotations = links.map(function (link, index) { return (contentId + 1 + index) + ' 0 R'; });
      pageIds.push(pageId);
      var imageBytes = window.atob(page.jpeg.split(',')[1]);
      var stream = 'q 612 0 0 792 0 0 cm /Artwork Do Q\n' + page.text.map(function (line) {
        return 'BT /F1 ' + line.size + ' Tf 3 Tr 1 0 0 1 ' + line.x + ' ' + (792 - line.y) + ' Tm (' + pdfSafe(line.text) + ') Tj ET';
      }).join('\n');
      objects.push('<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] /Resources << /Font << /F1 3 0 R >> /XObject << /Artwork ' + imageId + ' 0 R >> >> /Contents ' + contentId + ' 0 R /Annots [' + annotations.join(' ') + '] >>');
      objects.push('<< /Type /XObject /Subtype /Image /Width ' + page.width + ' /Height ' + page.height + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + imageBytes.length + ' >>\nstream\n' + imageBytes + '\nendstream');
      objects.push('<< /Length ' + stream.length + ' >>\nstream\n' + stream + '\nendstream');
      links.forEach(function (link) {
        objects.push('<< /Type /Annot /Subtype /Link /Rect [' + link.rect.join(' ') + '] /Border [0 0 0] /A << /S /URI /URI (' + pdfSafe(link.url) + ') >> >>');
      });
    });
    objects[0] = '<< /Type /Catalog /Pages 2 0 R >>';
    objects[1] = '<< /Type /Pages /Kids [' + pageIds.map(function (id) { return id + ' 0 R'; }).join(' ') + '] /Count ' + pageIds.length + ' >>';
    var title = 'Cozyology - ' + metadata.roomName + ' - Window ' + metadata.windowNumber;
    var titleHex = 'FEFF';
    for (var character = 0; character < title.length; character += 1) titleHex += title.charCodeAt(character).toString(16).padStart(4, '0');
    objects.push('<< /Title <' + titleHex + '> /Author (Cozyology) /Subject (Personalized measurement report) >>');
    var pdf = '%PDF-1.4\n';
    var offsets = [0];
    objects.forEach(function (object, index) {
      offsets.push(pdf.length);
      pdf += (index + 1) + ' 0 obj\n' + object + '\nendobj\n';
    });
    var xref = pdf.length;
    pdf += 'xref\n0 ' + (objects.length + 1) + '\n0000000000 65535 f \n';
    offsets.slice(1).forEach(function (offset) { pdf += String(offset).padStart(10, '0') + ' 00000 n \n'; });
    pdf += 'trailer\n<< /Size ' + (objects.length + 1) + ' /Root 1 0 R /Info ' + objects.length + ' 0 R >>\nstartxref\n' + xref + '\n%%EOF';
    var bytes = new Uint8Array(pdf.length);
    for (var i = 0; i < pdf.length; i += 1) bytes[i] = pdf.charCodeAt(i) & 255;
    return bytes;
  }

  function loadReportLogo() {
    var original = document.querySelector('img.logo__image');
    if (!original) return Promise.reject(new Error('The storefront logo is not available.'));
    var source = new window.URL(original.currentSrc || original.src, document.baseURI);
    if (source.hostname === 'cdn.shopify.com') {
      source.protocol = 'https:';
      source.searchParams.set('width', '851');
    }
    return new Promise(function (resolve, reject) {
      var logo = new window.Image();
      var timer = window.setTimeout(function () { reject(new Error('Logo loading timed out.')); }, 15000);
      logo.crossOrigin = 'anonymous';
      logo.onload = function () { window.clearTimeout(timer); resolve(logo); };
      logo.onerror = function () { window.clearTimeout(timer); reject(new Error('Logo loading failed.')); };
      logo.src = source.href;
    });
  }

  function loadFabricDiagram(url) {
    if (!url) return Promise.resolve(null);
    return new Promise(function (resolve, reject) {
      var illustration = new window.Image();
      var timer = window.setTimeout(function () { reject(new Error('Illustration loading timed out.')); }, 15000);
      illustration.crossOrigin = 'anonymous';
      illustration.onload = function () { window.clearTimeout(timer); resolve(illustration); };
      illustration.onerror = function () { window.clearTimeout(timer); reject(new Error('Illustration loading failed.')); };
      illustration.src = url;
    });
  }

  async function createReportArtwork(measurement, metadata, illustrationUrl) {
    var isDrapery = measurement.measurementType === 'drapery';
    var contentBottom = isDrapery ? 706 : 638;
    var branding = await Promise.all([
      loadReportLogo(),
      document.fonts.load('32px "American_bt"'),
      document.fonts.load('12px "Nunito Sans"'),
      document.fonts.load('600 12px "Nunito Sans"'),
      loadFabricDiagram(orderDiagramUrl(measurement, illustrationUrl))
    ]);
    var logo = branding[0];
    var pages = [];
    var page;
    var context;
    var body = '"Nunito Sans", Arial, sans-serif';
    var heading = '"American_bt", Georgia, serif';
    var ink = '#202020';
    var muted = '#6f6a66';

    function font(size, family, weight) { return (weight || '400') + ' ' + size + 'px ' + (family || body); }
    function line(text, x, y, size, options) {
      options = options || {};
      context.font = font(size, options.family, options.weight);
      context.fillStyle = options.color || ink;
      context.textAlign = options.align || 'left';
      context.fillText(text, x, y);
      var width = context.measureText(text).width;
      page.text.push({ text: text, size: size, x: x - (options.align === 'center' ? width / 2 : options.align === 'right' ? width : 0), y: y });
      if (options.url) {
        page.links.push({ url: options.url, rect: [x, 792 - y - 5, x + width, 792 - y + size] });
        context.strokeStyle = options.color || ink;
        context.lineWidth = 0.5;
        context.beginPath(); context.moveTo(x, y + 3); context.lineTo(x + width, y + 3); context.stroke();
      }
    }
    function wrap(value, width, size, family, weight) {
      context.font = font(size, family, weight);
      var result = [];
      var current = '';
      // Character fallback keeps long unspaced room names (including Chinese) intact.
      cleanText(value).split(/\s+/).forEach(function (word) {
        var next = current ? current + ' ' + word : word;
        if (context.measureText(next).width <= width) { current = next; return; }
        if (current) result.push(current);
        current = '';
        Array.from(word).forEach(function (character) {
          if (current && context.measureText(current + character).width > width) { result.push(current); current = ''; }
          current += character;
        });
      });
      if (current) result.push(current);
      return result;
    }
    function rule(y, left, right) {
      context.strokeStyle = '#ddd8d3';
      context.lineWidth = 0.6;
      context.beginPath(); context.moveTo(left || 48, y); context.lineTo(right || 564, y); context.stroke();
    }
    function newPage(continued) {
      var canvas = document.createElement('canvas');
      canvas.width = 1836; canvas.height = 2376;
      context = canvas.getContext('2d');
      if (!context) throw new Error('Report rendering is unavailable.');
      context.scale(3, 3);
      context.fillStyle = '#fff'; context.fillRect(0, 0, 612, 792);
      page = { canvas: canvas, text: [], links: [] };
      pages.push(page);
      context.drawImage(logo, 48, 36, 140, 140 * logo.naturalHeight / logo.naturalWidth);
      line('MEASUREMENT REPORT', 564, 50, 10, { align: 'right', weight: '600' });
      line(new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date()), 564, 69, 10, { align: 'right', color: muted });
      rule(102);
      var titleSize = continued ? 24 : 30;
      var titleLines = wrap(isDrapery && continued ? 'Your measurement report' : metadata.roomName || 'Your measurement report', 516, titleSize, heading);
      titleLines.forEach(function (text, index) { line(text, 48, 142 + index * 36, titleSize, { family: heading }); });
      var captionY = 142 + (titleLines.length - 1) * 36 + 26;
      var captions = wrap(metadata.productType + (metadata.windowNumber ? ' · Window ' + metadata.windowNumber : '') + (continued ? ' · Continued' : ''), 516, 12);
      captions.forEach(function (text, index) { line(text, 48, captionY + index * 17, 12, { color: muted }); });
      return captionY + (captions.length - 1) * 17 + 24;
    }

    var y = newPage(false);
    var heroHeight = measurement.quantity ? 166 : 148;
    context.fillStyle = '#f5f4f2'; context.fillRect(48, y, 516, heroHeight);
    line(measurement.orderKind, 306, y + 27, 12, { align: 'center', color: muted });
    var widthText = measurement.width + '"';
    var lengthText = measurement.length + '"';
    var size = 44;
    context.font = font(size, heading);
    while (size > 22 && Math.max(context.measureText(widthText).width, context.measureText(lengthText).width) > 214) {
      size -= 1; context.font = font(size, heading);
    }
    line(widthText, 177, y + 87, size, { align: 'center', family: heading });
    line('×', 306, y + 84, 23, { align: 'center', color: '#a49a91' });
    line(lengthText, 435, y + 87, size, { align: 'center', family: heading });
    line('WIDTH (INCHES)', 177, y + 112, 9, { align: 'center', color: muted, weight: '600' });
    line('LENGTH (INCHES)', 435, y + 112, 9, { align: 'center', color: muted, weight: '600' });
    if (measurement.quantity) line('Order quantity: ' + measurement.quantity, 306, y + 145, 14, { align: 'center', weight: '600' });
    y += heroHeight + 35;
    if (branding[4]) {
      var orderLabels = orderDiagramLabels(measurement);
      var orderImageHeight = 180 * branding[4].naturalHeight / branding[4].naturalWidth;
      if (y + orderImageHeight + 56 > contentBottom) y = newPage(true);
      line(orderLabels.width + ': ' + measurement.width + '″ W', 285, y + 12, 11, { align: 'center', weight: '600' });
      context.drawImage(branding[4], 195, y + 20, 180, orderImageHeight);
      line('Order length', 423, y + 90, 10, { align: 'center', color: muted });
      line(measurement.length + '″ L', 423, y + 109, 12, { align: 'center', weight: '600' });
      line(orderLabels.note, 306, y + orderImageHeight + 40, 10, { align: 'center', color: muted });
      y += orderImageHeight + 64;
    }
    if (y + 80 > contentBottom) y = newPage(true);
    line('Measurement details', 48, y, 18, { family: heading });
    y += 24;
    var details = [];
    var seen = {};
    function add(label, value) {
      if (/^quantity$/i.test(cleanText(label)) && measurement.quantity) return;
      // pdfDetailRows owns fullness copy; never restore the native legacy
      // fixed 2.2 value or merge the separate explanation into the value row.
      var key = cleanText(label).toLowerCase();
      if (!value || seen[key]) return;
      seen[key] = true; details.push({ label: cleanText(label), value: cleanText(value) });
    }
    pdfDetailRows(measurement).forEach(function (row) { add(row.label, row.value); });
    for (var index = 0; index < details.length; index += 2) {
      var cells = details.slice(index, index + 2).map(function (detail) {
        return { label: wrap(detail.label, 242, 10), value: wrap(detail.value, 242, 12, body, '600') };
      });
      var height = Math.max.apply(null, cells.map(function (cell) { return cell.label.length * 13 + cell.value.length * 17 + 19; }));
      // Keep detail rows above this report type's footer.
      if (y + height > contentBottom) {
        y = newPage(true);
        line('Measurement details', 48, y, 18, { family: heading }); y += 24;
      }
      cells.forEach(function (cell, column) {
        var x = 48 + column * 274;
        cell.label.forEach(function (text, i) { line(text, x, y + 10 + i * 13, 10, { color: muted }); });
        cell.value.forEach(function (text, i) { line(text, x, y + 10 + cell.label.length * 13 + 5 + i * 17, 12, { weight: '600' }); });
        rule(y + height - 5, x, x + 242);
      });
      y += height;
    }
    pages.forEach(function (item, index) {
      page = item; context = item.canvas.getContext('2d');
      if (isDrapery) {
        rule(722);
        line('Please double-check every measurement before ordering.', 48, 740, 10, { color: muted });
        if (index === pages.length - 1) {
          line('Email: design@cozyology.com', 48, 757, 10, { color: '#ba6352', url: SUPPORT_EMAIL });
          line('Book a free Zoom consultation', 322, 757, 10, { color: '#ba6352', url: CONSULTATION_URL });
        }
      } else {
        rule(650);
        line('Unsure about your measurements?', 48, 672, 14, { family: heading });
        line('Email: design@cozyology.com', 48, 696, 11, { color: '#ba6352', url: SUPPORT_EMAIL });
        line('Book a free Zoom consultation', 322, 696, 11, { color: '#ba6352', url: CONSULTATION_URL });
        rule(718);
        line('Please double-check every measurement before ordering.', 48, 738, 10, { color: muted });
        line('Prepared from your measurement tool selections.', 48, 754, 9, { color: muted });
      }
      line('cozyology.com', 48, 778, 10, { weight: '600' });
      line((index + 1) + ' / ' + pages.length, 564, 778, 9, { align: 'right', color: muted });
      item.jpeg = item.canvas.toDataURL('image/jpeg', 0.96);
      item.width = item.canvas.width; item.height = item.canvas.height;
      item.canvas.width = 0; item.canvas.height = 0;
      delete item.canvas;
    });
    return pages;
  }

  function reportFilename(measurement, metadata) {
    var type = measurement.measurementType === 'drapery' ? 'drapery' : 'shade';
    var slug = function (value) { return value.replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-|-$/g, '').toLowerCase(); };
    return 'cozyology-' + type + (metadata.roomName ? '-' + slug(metadata.roomName) : '') + (metadata.windowNumber ? '-window-' + slug(metadata.windowNumber) : '') + '-report.pdf';
  }

  function releasePreparedReport(state) {
    if (state.preparedReport) window.URL.revokeObjectURL(state.preparedReport.url);
    state.preparedReport = null;
    state.emailAttempt = null;
  }

  function preparedReportHtml(state) {
    var report = state.preparedReport;
    if (!report) return '';
    return '<section class="cz-measure-report__ready" aria-label="Your PDF is ready">' +
      '<p>Your PDF is ready' + (report.roomName ? ': ' + escapeHtml(report.roomName) : '') + (report.windowNumber ? ' · Window ' + escapeHtml(report.windowNumber) : '') + '</p>' +
      '<div><a class="cz-measure-report__text-action" href="' + escapeHtml(report.url) + '" download="' + escapeHtml(report.filename) + '">Save PDF</a>' +
      '<a class="cz-measure-report__text-action" href="' + escapeHtml(report.url) + '" target="_blank" rel="noopener">Open PDF</a></div>' +
      '<p>If it opens instead of saving, use your browser’s Share or Download option. On iPhone, choose Share → Save to Files.</p></section>';
  }

  async function prepareReport(state) {
    var measurement = state.current;
    var metadata = { productType: state.draft.productType, roomName: state.draft.roomName, windowNumber: state.draft.windowNumber };
    var signature = state.currentSignature;
    var key = JSON.stringify([signature, metadata]);
    if (state.preparedReport && state.preparedReport.key === key) return state.preparedReport;
    var artwork = await createReportArtwork(measurement, metadata, fabricDiagramUrl(state.component));
    if (state.currentSignature !== signature) throw new Error('The measurement changed.');
    var bytes = buildPdf(measurement, metadata, artwork);
    var blob = new Blob([bytes], { type: 'application/pdf' });
    releasePreparedReport(state);
    state.preparedReport = {
      key: key, bytes: bytes, blob: blob, url: window.URL.createObjectURL(blob),
      filename: reportFilename(measurement, metadata), roomName: metadata.roomName, windowNumber: metadata.windowNumber
    };
    return state.preparedReport;
  }

  async function downloadCurrent(state) {
    if (!state.current || state.downloadBusy || !validateDraft(state)) return;
    state.downloadBusy = true;
    state.dialogNotice = 'Preparing your personalized report…';
    render(state, true);
    try {
      var report = await prepareReport(state);
      var link = document.createElement('a');
      link.href = report.url;
      link.download = report.filename;
      link.hidden = true;
      document.body.appendChild(link);
      link.click();
      link.remove();
      // Keep a visible, user-gesture fallback: async generation may lose the
      // browser's download activation. A click isn't proof the file was saved.
      state.saveDialogOpen = false;
      state.notice = '';
      state.dialogNotice = '';
    } catch (error) {
      state.dialogNotice = 'We couldn’t prepare the PDF. Please check your connection and try again.';
    } finally {
      state.downloadBusy = false;
    }
    render(state, true);
    var fallback = state.container.querySelector('.cz-measure-report__ready a');
    if (fallback && !state.saveDialogOpen) fallback.focus();
  }

  function emailEndpoint(state) {
    var endpoint = state.component.getAttribute('data-report-email-url') || '';
    // Same-origin only; no credentials or third-party recipient data in assets.
    return /^\/(?!\/)[a-zA-Z0-9_\/-]+$/.test(endpoint) ? endpoint : '';
  }

  function bytesBase64(bytes) {
    var chunks = [];
    for (var offset = 0; offset < bytes.length; offset += 8192) {
      chunks.push(String.fromCharCode.apply(null, bytes.subarray(offset, offset + 8192)));
    }
    return window.btoa(chunks.join(''));
  }

  async function emailCurrent(state) {
    if (!state.current || state.downloadBusy || !validateDraft(state)) return;
    var endpoint = emailEndpoint(state);
    if (!endpoint) return;
    var recipient = state.draft.email;
    if (!/^[^\s@,;<>]+@[^\s@,;<>]+\.[^\s@,;<>]+$/.test(recipient)) return;
    state.downloadBusy = true;
    state.dialogNotice = 'Preparing your personalized report…';
    render(state, true);
    var timeout;
    try {
      var controller = new AbortController();
      var report = await prepareReport(state);
      var attemptKey = JSON.stringify([report.key, recipient]);
      if (!state.emailAttempt || state.emailAttempt.key !== attemptKey) {
        state.emailAttempt = { key: attemptKey, id: window.crypto.randomUUID() };
      }
      timeout = window.setTimeout(function () { controller.abort(); }, 20000);
      var response = await window.fetch(endpoint, {
        method: 'POST', credentials: 'same-origin', signal: controller.signal,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ recipient: recipient, roomName: report.roomName, windowNumber: report.windowNumber,
          filename: report.filename, pdfBase64: bytesBase64(report.bytes), requestId: state.emailAttempt.id })
      });
      var result = await response.json();
      if (!response.ok || !['preview', 'accepted'].includes(result.status)) throw new Error('Email unavailable.');
      state.notice = result.status === 'preview' ? 'Local email test complete — no email was sent. Your PDF is ready below.' :
        'Your report has been queued for email. Please check your inbox and spam folder shortly.';
      state.saveDialogOpen = false;
      state.dialogNotice = '';
    } catch (error) {
      state.dialogNotice = 'We couldn’t confirm the email request. Try again, or cancel and download your report.';
    } finally {
      if (timeout) window.clearTimeout(timeout);
      state.downloadBusy = false;
    }
    render(state, true);
  }

  function clickNativeAction(state, label) {
    var button = Array.prototype.slice.call(state.root.firstElementChild.querySelectorAll('button'))
      .find(function (candidate) { return cleanText(candidate.textContent) === label; });
    if (button && typeof button.click === 'function') button.click();
  }

  function installEvents(state) {
    state.container.addEventListener('toggle', function (event) {
      if (event.target.matches('.cz-measure-report__measurements')) {
        state.measurementsOpen = event.target.open;
      }
      if (event.target.matches('.cz-measure-report__fabric')) {
        state.fabricOpen = event.target.open;
      }
    }, true);
    state.container.addEventListener('input', function (event) {
      var field = event.target && event.target.getAttribute('data-report-field');
      if (field) {
        fieldValue(state, field, event.target.value);
        if (event.target.setCustomValidity) event.target.setCustomValidity('');
      }
    });
    state.container.addEventListener('submit', function (event) {
      if (!event.target || !event.target.matches('[data-report-form]')) return;
      event.preventDefault();
      if (state.dialogMode === 'download') downloadCurrent(state);
      else if (state.dialogMode === 'email') emailCurrent(state);
      else saveCurrent(state);
    });
    state.container.addEventListener('click', function (event) {
      if (event.target && event.target.hasAttribute && event.target.hasAttribute('data-report-dialog-backdrop')) {
        closeSaveDialog(state);
        return;
      }
      var button = event.target && event.target.closest ? event.target.closest('[data-report-action]') : null;
      if (!button) return;
      var action = button.getAttribute('data-report-action');
      if (action === 'calculate') {
        const url = new URL(window.location.href);
        if (url.searchParams.has('report-example')) {
          url.searchParams.delete('report-example');
          window.history.replaceState(window.history.state, '', url.href);
          const label = document.querySelector('.cz-review-banner [data-review-example-label]');
          if (label) label.textContent = '';
        }
        clickNativeAction(state, 'CALCULATE AGAIN');
      }
      if (action === 'open-save') openSaveDialog(state);
      if (action === 'cancel-save') closeSaveDialog(state);
      if (action === 'download') openSaveDialog(state, 'download');
      if (action === 'email') openSaveDialog(state, 'email');
      if (action === 'message') {
        var launcher = document.querySelector('[data-cz-contact-open]');
        if (launcher) {
          // Reuse the storefront form; never send a message from this action.
          var restoreFocus = function (event) {
            if (event.detail && event.detail.open === false) {
              window.removeEventListener('cz-contact-state', restoreFocus);
              window.requestAnimationFrame(function () {
                var currentButton = state.container.querySelector('[data-report-action="message"]');
                if (currentButton) currentButton.focus();
              });
            }
          };
          window.addEventListener('cz-contact-state', restoreFocus);
          launcher.click();
        } else {
          state.notice = 'The message form is unavailable. Please email us or book a free Zoom consultation below.';
          render(state);
        }
      }
    });
    state.container.addEventListener('cancel', function (event) {
      if (!event.target.matches('[data-report-dialog-backdrop]')) return;
      event.preventDefault();
      closeSaveDialog(state);
    }, true);
    state.container.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && state.saveDialogOpen) {
        event.preventDefault();
        closeSaveDialog(state);
      }
    });
  }

  function addStyles(component, root) {
    [component.getAttribute('data-foundation-style-url'), component.getAttribute('data-report-style-url'), component.getAttribute('data-report-layout-url')]
      .filter(Boolean)
      .forEach(function (url) {
        if (root.querySelector('link[href="' + url.replace(/"/g, '\\"') + '"]')) return;
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        root.appendChild(link);
      });
  }

  function installComponent(component) {
    var root = component.shadowRoot;
    if (!root || installedComponents.has(component)) return false;
    addStyles(component, root);
    var header = document.querySelector('.section-header');
    function headerClearance() { component.style.setProperty('--cz-review-header-height', (header ? header.getBoundingClientRect().height : 0) + 'px'); }
    headerClearance();
    if (header && window.ResizeObserver) new ResizeObserver(headerClearance).observe(header);
    var container = document.createElement('div');
    container.className = 'cz-measure-report-root';
    root.appendChild(container);
    var state = createState(component, root, container);
    installedComponents.set(component, state);
    activeStates.push(state);
    installEvents(state);
    component.addEventListener('cz-measurement-state', function () {
      state.eventSnapshot = component.czMeasurementState;
      syncLiveResult(state);
    });

    var scheduled = false;
    var observer = new MutationObserver(function (mutations) {
      var outsideReport = mutations.some(function (mutation) {
        return mutation.target !== container && !container.contains(mutation.target);
      });
      if (!outsideReport || scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        if (state.eventSnapshot && state.eventSnapshot === component.czMeasurementState) return;
        syncLiveResult(state);
      });
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    state.observer = observer;
    syncLiveResult(state);
    return true;
  }

  function installAll() {
    function installReadyComponents() {
      var installed = 0;
      document.querySelectorAll('cozyology-measurement-tool').forEach(function (component) {
        if (installComponent(component)) installed += 1;
      });
      return installed;
    }
    // Attach before the first native result render, rather than exposing the
    // legacy result until the first 250ms polling tick. Also handle a calculator
    // module that arrives after the fallback polling window has expired.
    var timer = null;
    function stopPolling() {
      if (timer === null) return;
      window.clearInterval(timer);
      timer = null;
    }
    var installed = installReadyComponents();
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('cozyology-measurement-tool').then(function () {
        if (installReadyComponents()) stopPolling();
      });
    }
    if (installed) return;
    var attempts = 0;
    timer = window.setInterval(function () {
      attempts += 1;
      if (installReadyComponents() || attempts >= 120) stopPolling();
    }, 250);
  }

  function boot() {
    installAll();
    window.addEventListener('storage', function (event) {
      if (event.key !== STORAGE_KEY) return;
      activeStates.forEach(function (state) {
        state.reports = readReports();
        render(state, true);
      });
    });
  }

  window.CozyologyMeasurementReport = {
    version: VERSION,
    storageKey: STORAGE_KEY,
    cleanText: cleanText,
    parseReportData: parseReportData,
    currentBranchData: currentBranchData,
    reportDetailRows: reportDetailRows,
    fabricUsage: fabricUsage,
    fabricUsageRows: fabricUsageRows,
    fabricUsageHtml: fabricUsageHtml,
    fabricDiagramHtml: fabricDiagramHtml,
    reportSignature: reportSignature,
    orderInformationHtml: orderInformationHtml,
    orderSizeDiagramHtml: orderSizeDiagramHtml,
    orderOverviewHtml: orderOverviewHtml,
    measurementsHtml: measurementsHtml,
    reportFilename: reportFilename,
    preparedReportHtml: preparedReportHtml,
    emailEndpoint: emailEndpoint,
    buildPdf: buildPdf,
    readReports: readReports,
    writeReports: writeReports
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
